__turbopack_context__.v({
  "active": "Bottombar-module__4HLmzG__active",
  "bottomBar": "Bottombar-module__4HLmzG__bottomBar",
  "container": "Bottombar-module__4HLmzG__container",
  "icon": "Bottombar-module__4HLmzG__icon",
  "section": "Bottombar-module__4HLmzG__section",
});
